import Avatar from '../../../assets/images/avatar.png';

export const getDefaultValue = (inputType: string) => {
  switch (inputType) {
    default:
    case 'text':
      return '';
    case 'image':
      return Avatar;
  }
}


// WEBPACK FOOTER //
// ./src/scripts/components/UserContactsForm/utils.js